import { styled } from '@mui/material'

export const EditorContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
})

export const EditorWrapper = styled('div')({
  boxSizing: 'border-box',
  border: '1px solid #333',
  cursor: 'text',
  borderRadius: '5px',
  backgroundColor: '#fff',
  fontSize: '14px',
  lineHeight: 1.6,
  '& .ProseMirror': {
    outline: 'none',
    minHeight: '44px',
    padding: '8px',
    '& p': {
      margin: 0,
    },
    '& ul, & ol': {
      paddingLeft: '16px',
      margin: '4px 0',
    },
    '& li': {
      margin: '2px 0',
    },
    '& strong': {
      fontWeight: 'bold',
    },
    '& em': {
      fontStyle: 'italic',
    },
    '& .custom-link': {
      color: '#1976d2',
      textDecoration: 'underline',
    },
    '& .mention': {
      backgroundColor: '#e3f2fd',
      color: '#1976d2',
      padding: '2px 4px',
      borderRadius: '3px',
      fontSize: '13px',
      fontWeight: '500',
      textDecoration: 'none',
      '&:hover': {
        backgroundColor: '#bbdefb',
      },
    },
  },
  '& .ProseMirror p.is-editor-empty:first-child::before': {
    color: '#adb5bd',
    content: 'attr(data-placeholder)',
    float: 'left',
    height: 0,
    pointerEvents: 'none',
  },
})

export const MarkupToolbarItems = styled('div')({
  display: 'flex',
  overflow: 'hidden',
})

export const ButtonContainer = styled('div')({
  display: 'flex',
  gap: '8px',
  justifyContent: 'flex-start',
  marginTop: '8px',
})

export const CancelButton = styled('button')({
  padding: '6px 16px',
  backgroundColor: '#f5f5f5',
  color: '#666',
  border: '1px solid #ccc',
  borderRadius: '4px',
  fontSize: '14px',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#eeeeee',
  },
})
